import { CHAINS } from "./chains";
import { setFallbackChainId } from "../web3";
import { walletConnectV2 } from "../../connectors/walletConnectV2";

// Helper function to detect the active connector type
const getActiveConnector = () => {
  // You'll need to adapt this based on your web3-react setup
  // This assumes you're tracking the active connector somewhere
  // You might have this in a context or state management
  return {
    isWalletConnect: walletConnectV2.provider?.connected || false,
    isMetaMask: window.ethereum?.isMetaMask || false,
    isTrustWallet: window.ethereum?.isTrust || false,
  };
};

export const switchChain = async (chainId, index) => {
  const chain = CHAINS.find((c) => c.chainId === chainId);
  if (!chain?.chainIdHex) {
    return { success: false, error: new Error("Invalid chain") };
  }

  console.log(chain, "chainchain");

  const activeConnector = getActiveConnector();

  try {
    // Handle WalletConnect v2
    if (activeConnector.isWalletConnect && walletConnectV2.provider) {
      console.log("Switching chain via WalletConnect");

      try {
        // For WalletConnect v2, use the provider's request method
        await walletConnectV2.provider.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: chain.chainIdHex }],
        });

        setFallbackChainId(chainId, index);
        return { success: true };
      } catch (wcError) {
        console.warn(
          "WalletConnect switch failed, trying to add chain",
          wcError
        );

        if (wcError.code === 4902 && chain.rpcUrls?.[0]) {
          try {
            await walletConnectV2.provider.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: chain.chainIdHex,
                  chainName: chain.name,
                  rpcUrls: chain.rpcUrls,
                  nativeCurrency: chain.nativeCurrency,
                  blockExplorerUrls: chain.blockExplorerUrls || [],
                },
              ],
            });

            // Retry switch after adding
            await walletConnectV2.provider.request({
              method: "wallet_switchEthereumChain",
              params: [{ chainId: chain.chainIdHex }],
            });

            setFallbackChainId(chainId, index);
            return { success: true };
          } catch (addError) {
            console.error("Adding chain via WalletConnect failed", addError);
            return { success: false, error: addError };
          }
        }

        return { success: false, error: wcError };
      }
    }

    // Handle injected wallets (MetaMask, Trust Wallet, etc.)
    if (window.ethereum) {
      console.log("Switching chain via injected wallet");

      try {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: chain.chainIdHex }],
        });

        setFallbackChainId(chainId, index);
        return { success: true };
      } catch (err) {
        console.warn("Injected wallet switch failed, trying to add chain", err);

        if (err.code === 4902 && chain.rpcUrls?.[0]) {
          try {
            await window.ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: chain.chainIdHex,
                  chainName: chain.name,
                  rpcUrls: chain.rpcUrls,
                  nativeCurrency: chain.nativeCurrency,
                  blockExplorerUrls: chain.blockExplorerUrls || [],
                },
              ],
            });

            // Retry switch after adding
            await window.ethereum.request({
              method: "wallet_switchEthereumChain",
              params: [{ chainId: chain.chainIdHex }],
            });

            setFallbackChainId(chainId, index);
            return { success: true };
          } catch (addError) {
            console.error("Adding chain via injected wallet failed", addError);
            return { success: false, error: addError };
          }
        }

        console.error("Injected wallet chain switch failed", err);
        return { success: false, error: err };
      }
    }

    return {
      success: false,
      error: new Error("No compatible wallet provider found"),
    };
  } catch (error) {
    console.error("Chain switch failed", error);
    return { success: false, error };
  }
};

// Alternative approach using web3-react hooks
export const switchChainWithHooks = async (chainId, index, connector) => {
  const chain = CHAINS.find((c) => c.chainId === chainId);
  if (!chain?.chainIdHex) {
    return { success: false, error: new Error("Invalid chain") };
  }

  try {
    // Use the connector's activate method with the new chain
    if (connector && typeof connector.activate === "function") {
      await connector.activate(chainId);
      setFallbackChainId(chainId, index);
      return { success: true };
    }

    // Fallback to the original method
    return await switchChain(chainId, index);
  } catch (error) {
    console.error("Chain switch with hooks failed", error);
    return { success: false, error };
  }
};
